import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'
import useViewport from 'hooks/useViewport'

import classes from './SubSectionTitle.module.scss'

/** @type {import("./types").default} */
const SubSectionTitle = ({ columns, label }) => {
  const { up } = useViewport()
  const mobileContainer = columns > 2 ? classes.mobileContainerOver2Cols : classes.mobileContainer

  return (
    <div className={clsx('SubSectionTitle', classes.container)}>
      {up('md') ? (
        <div className={classes.container}>
          <Typography variant="heading-sm" component="p" className={classes.subtitle1}>
            {label}
          </Typography>
        </div>
      ) : (
        <div className={classes.container}>
          <div className={mobileContainer}>
            <Typography variant="heading-sm" component="p" className={classes.subtitle1}>
              {label}
            </Typography>
          </div>
        </div>
      )}
    </div>
  )
}

export default SubSectionTitle
